import React from 'react';
import KaratCheckboxDropdownBase from '../../KaratCheckboxDropdown';

/**
 * Reusable Karat Checkbox Dropdown for Summary widgets (compact variant).
 */
export default function KaratCheckboxDropdown(props) {
  return <KaratCheckboxDropdownBase variant="compact" {...props} />;
}
